import { createContext, useContext } from 'react';

export interface IExternalLoginContext {
  assetType?: string;
  requireUserConsent?: boolean;
  company?: string;
}

export const ExternalLoginContext = createContext<IExternalLoginContext>({} as IExternalLoginContext);
export const ExternalLoginContextProvider = ExternalLoginContext.Provider;

export const useExternalLoginContext = () => {
  return useContext(ExternalLoginContext);
};
